import { Stack } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { LabeledValue } from 'core/elements';
import { useCostDecimals } from 'pricing/hooks';
import { IPricingSourceData } from 'quotes/types';
import { getPricingSourceDisplayFields } from 'quotes/utils';
import { Level } from 'theme/enums';

// Block greyed as a whole, but only the VALUES are struck through — labels stay legible so the
// user can still identify what the unused agreement was (Oana, 2026-08-27).
export const pricingSourceNotInUseSx = {
  color: 'text.tertiary',
};

export const pricingSourceNotInUseValueSx = {
  textDecoration: 'line-through',
};

interface IProps {
  // A selected SPA arrives in the automatic block's shape (getEffectiveSpaInfo).
  pricingData?: IPricingSourceData;
  spaCostCurrency?: string | null;
  isStruckThrough?: boolean;
}

export const ExternalPricingSourceContent = ({
  pricingData,
  spaCostCurrency,
  isStruckThrough = false,
}: IProps) => {
  const { t } = useTranslation();
  const costDecimals = useCostDecimals();

  const fields = getPricingSourceDisplayFields(pricingData, costDecimals, { spaCostCurrency });

  return (
    <Stack sx={{ gap: 0, ...(isStruckThrough && pricingSourceNotInUseSx) }}>
      {fields.map(({ labelKey, value }) => (
        <LabeledValue
          key={labelKey}
          label={t(labelKey)}
          value={value || DEFAULT_PLACEHOLDER}
          options={{
            labelLevel: Level.BODY_XS,
            labelSx: { color: 'inherit', whiteSpace: 'nowrap' },
            valueSx: { ...(isStruckThrough && pricingSourceNotInUseValueSx) },
            inline: true,
          }}
        />
      ))}
    </Stack>
  );
};
